import User from "../../modules/accounts/models/User"
import FlexRow from "../base/FlexRow"
import { Link, useNavigate } from "react-router-dom"
import AccountHeaderTechStatistics from "./AccountHeaderTechStatistics"
import { UserTypes } from "../../core/Enums"
import AccountHeaderAgentStatistics from "./AccountHeaderAgentStatistics"
import AccountTechStatusStrip from "./AccountTechStatusStrip"
import { TechBatteryBadge } from "../tech/TechBatteryLabel"
import Map from "../here/Map"
import { useEffect, useState } from "react"


type Props = {
    userId?: string
    model?: User
    selectedPage?: string
}

export default function AccountOverviewHeader(props: Props) {


    const navigate = useNavigate()
    const [mapHeight, mapHeightSet] = useState<number>()
    const [mapWidth, mapWidthSet] = useState<number>()
    const [buildMap, buildMapSet] = useState<boolean>(false)

    const setSize = () => {
        var h = $("#card-account-header").height();
        var w = ($("#card-account-header").width() ?? 800) / 2;
        mapHeightSet(h);
        mapWidthSet(w);
    }

    useEffect(() => {

        setSize();
        window.addEventListener("resize", setSize);

        return () => {
            window.removeEventListener("resize", setSize);
        }

    }, [])


    useEffect(() => {
        if (mapWidth && mapHeight) buildMapSet(true)
    }, [mapWidth, mapHeight])



    return (
        <div id="card-account-header" className="card">
            <div className="card-body pt-9 pb-0 position-relative">
                <div className="d-flex mb-3">
                    <div className="me-7 mb-4">
                        <div className="d-flex flex-column">
                            <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                <img src={props.model?.avatarUrl ?? "/assets/media/avatars/blank.png"} />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="d-flex align-items-center mb-1">
                            <div className="text-gray-900 fs-2 fw-bolder">
                                {props.model?.firstName + " " + props.model?.lastName}
                            </div>
                            {/* Their phone's battery, beside the name, as in the drawer. */}
                            {
                                props.model?.userType == UserTypes.Technician &&
                                <div className="ms-4">
                                    <TechBatteryBadge techId={props.model?.id} large />
                                </div>
                            }
                        </div>

                        <FlexRow>
                            <FlexRow className="text-gray-900 fs-7 me-10" title="Username">
                                <span className="svg-icon svg-icon-4 me-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path opacity="0.3" d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z" fill="black"></path>
                                        <path d="M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z" fill="black"></path>
                                    </svg>
                                </span>
                                <span>
                                    {props.model?.username}
                                </span>
                            </FlexRow>
                            <FlexRow className="text-gray-900 fs-7 me-5" title="User Type">
                                <span className="svg-icon svg-icon-4 me-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path opacity="0.3" d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z" fill="black"></path>
                                        <path d="M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z" fill="black"></path>
                                    </svg>
                                </span>
                                <span>
                                    {props.model?.userTypeName}
                                </span>
                            </FlexRow>

                        </FlexRow>

                        {
                            props.model?.userType == UserTypes.Technician && <AccountTechStatusStrip tech={props.model} />
                        }

                        {/* {
                            props.model?.userType == UserTypes.Technician && <AccountHeaderTechStatistics />
                        }
                        {
                            props.model?.userType == UserTypes.Agent && <AccountHeaderAgentStatistics />
                        } */}

                    </div>
                    <FlexRow justify="end" className="flex-grow-1">

                    </FlexRow>
                </div>

                {
                    (props.model?.techLocation || props.model?.techWakeupAddress?.position) &&
                    <>
                        <div className="tech-header-map" style={{ width: mapWidth }}>

                            <Map id="map-tech-live" build={buildMap}
                                height={mapHeight}
                                techMarker={props.model.techLocation ?? props.model.techWakeupAddress?.position}
                                center={props.model?.techLocation ?? props.model.techWakeupAddress?.position}
                                zoom={12} />

                        </div>
                        <div className="tech-header-map-layer"
                            style={{
                                width: mapWidth,
                                height: mapHeight,
                                cursor: "pointer"
                            }}
                            onClick={e => {
                                e.preventDefault()
                                if (props.model?.techLocation) navigate(`/accounts/manage/${props.model.id}/live-location`)
                                else navigate(`/accounts/manage/${props.model?.id}/address-metro`)
                            }}>
                        </div>
                    </>
                }



            </div>
        </div>
    )
}